// payloadBuilders.ts

export const buildLookupPayload = (inputValues: Record<string, string>) => {
  const payload: Record<string, any> = {};

  Object.entries(inputValues).forEach(([key, value]) => {
    if (typeof value === "string" && value.trim() !== "") {
      payload[key] = { lookup_field: value.trim() };
    }
  });

  if (Object.keys(payload).length === 0) return null;

  const formatted = JSON.stringify(payload).replace(/"/g, '"');
  return `{${formatted.slice(1, -1)}}`;
};
export const buildRowFilteringPayload = (
  activityDate: any,
  filterRows: any[],
) => {
  const filteringDef: Record<string, any> = {};

  const rawFormats = [
    activityDate.rawTableFormat,
    activityDate.additionalRawTableFormat,
  ]
    .map((f) => f?.trim())
    .filter(Boolean);

  filteringDef["activity_date"] = {
    field: activityDate.field,
    raw_table_format: rawFormats,
    ...(activityDate.filteringFormat && {
      filtering_format: activityDate.filteringFormat,
    }),
  };

  for (const row of filterRows) {
    if (!row.fieldName) continue;

    filteringDef[row.fieldName] = {
      value:
        typeof row.value === "string" && row.value.trim()
          ? [row.value.trim()]
          : [],
      condition: (row.condition || "").toLowerCase().replace(/\s+/g, "_"),
    };
  }

  const formatted = JSON.stringify(filteringDef).replace(/"/g, '"');
  return `{${formatted.slice(1, -1)}}`;
};
